import { render, staticRenderFns } from "./actionsTableDataRegistered.vue?vue&type=template&id=7a84b2ea"
import script from "./actionsTableDataRegistered.vue?vue&type=script&lang=js"
export * from "./actionsTableDataRegistered.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a84b2ea')) {
      api.createRecord('7a84b2ea', component.options)
    } else {
      api.reload('7a84b2ea', component.options)
    }
    module.hot.accept("./actionsTableDataRegistered.vue?vue&type=template&id=7a84b2ea", function () {
      api.rerender('7a84b2ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/transport/sellers/components/actionsTableDataRegistered.vue"
export default component.exports